import { MAX_PARTNERS_BY_DRAFTS } from 'constants/defaultConstants';
import { getStockPlans } from 'modules/beneficiaries/redux/planActions';
import { useGetPartners } from 'modules/partners/hooks/useGetPartners';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { getDrafts } from '../redux/draftActions';

type UseDraftSafeProps = {
  societyId: string;
};

const useDraftSafe = ({ societyId }: UseDraftSafeProps) => {
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  );
  const drafts = useSelector((state: State) => state?.drafts);
  const holdingClasses = useSelector((state: State) => state?.holdingClasses);
  const operations = useSelector((state: State) => state?.operations);
  const partners = useSelector((state: State) => state?.partners);
  const plans = useSelector((state: State) => state?.plans);
  const user = useSelector((state: State) => state?.user);

  useGetActualSociety(societyId);

  useGetPartners({
    societyId,
    partnerId: '',
    categoryId: '',
    page: 1,
    items: MAX_PARTNERS_BY_DRAFTS,
  });

  const planUnits = useMemo(
    () =>
      plans
        ?.filter((plan) => !plan?.isDraft)
        ?.reduce((acc, plan) => acc + (plan?.sharesTotal || 0), 0),
    [plans]
  );

  useEffect(() => {
    if (societyId) {
      dispatch(getHoldingClasses({ societyId }));
      dispatch(getStockPlans(societyId));
    }
  }, [societyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (societyId && !drafts?.length) {
      dispatch(getDrafts(societyId));
    }
  }, [societyId, drafts]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data: {
      actualSociety,
      drafts,
      holdingClasses,
      operations,
      partners,
      plans,
      planUnits,
      user,
    },
    isLoading: false,
    isError: false,
  };
};

export default useDraftSafe;
